export class ForecastWeatherDto {
  id: number;
  day: string;
  weatherCode: number;
  temperature2mMax: number;
  temperature2mMin: number;
  temperature2mMean: number;
}